import React from "react";
import { Icons } from "../../../../icons";
import { Tag, TagRemoveButton } from "../Select.styles";

interface TagButtonProps {
  label: string;
  value: string;
  onRemove: (value: string) => void;
  disabled?: boolean;
}

export const TagButton: React.FC<TagButtonProps> = ({
  label,
  value,
  onRemove,
  disabled = false,
}) => {
  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!disabled) {
      onRemove(value);
    }
  };

  return (
    <Tag data-testid="tag">
      {label}
      <TagRemoveButton
        type="button"
        onClick={handleRemove}
        disabled={disabled}
        aria-label={`Remover ${label}`}
      >
        <Icons name="iconClose" width={14} height={14} />
      </TagRemoveButton>
    </Tag>
  );
};
